
export default {

  SET_RULE_TEMPLATE_PAGINATED(state, ruleTemplateData) {
    state.ruleTemplateData = ruleTemplateData;
  }
}
